export default __webpack_public_path__ + "static/media/w_arrow-left18.4a7f424e.svg";